'use client'
import React, { useRef, useState } from 'react'
import Header from './header'
import { useLazyQuery } from '@apollo/client'
import { MATCH_DETAIL } from '@/graphql/match/match.query'
import usePolling from '@/shared/hooks/usePolling'
import getStatus from '@/shared/hooks/useStatus'
import { useRouter } from 'next/navigation'

export default function HeaderWrapper({ matchDetails, slug }: any) {
	const { sLiveGameStatusStr } = getStatus(matchDetails)
	const statusRef = useRef(sLiveGameStatusStr)
	const [data, setData] = useState(matchDetails)
	const [getMatchData] = useLazyQuery(MATCH_DETAIL, {
		fetchPolicy: 'no-cache',
		variables: { input: { _id: data?.oSeo?.iId } },
	})
	const router = useRouter()
	usePolling(
		() =>
			getMatchData().then(({ data }) => {
				if (data?.getMatchById) {
					setData(data?.getMatchById)
					const currentStatus = getStatus(data?.getMatchById)?.sLiveGameStatusStr

					if (currentStatus !== statusRef.current && currentStatus) {
						router.refresh()
					}
				}
			}),
		{
			deps: [data?.oStatus?.sValue],
			interval: 5000,
			skip: data?.oStatus?.sValue === 'completed' || data?.oStatus?.sValue === 'cancelled',
		}
	)

	return <Header slug={slug} data={data} />
}
